export default "__VITE_ASSET__COu9u7El__"